import styled from 'styled-components';

import { ExpandIcon } from '../../icons';
import { colors } from 'styles/colors';
import { CHAT_PANEL_WIDTH } from '~/components/CelsiusAIChat/styles';

export const Container = styled.header<{ MenuOpen: boolean, CelsiusOpen?: boolean }>(
  ({ MenuOpen, CelsiusOpen }) => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${colors.White};
  border-bottom: 1px solid #74747433;
  top: 0;
  left: 0;
  height: 40px;
  padding: ${MenuOpen ? '25px 40px' : '25px 20px'};
  position: fixed;
  width: ${CelsiusOpen ? `calc(100vw - ${CHAT_PANEL_WIDTH}px)` : '100vw'};
  transition: width 0.25s ease;
  z-index: 899;
  font-size: 13px;
`,
);

export const SelectPlataformInfo = styled.div`
  color: ${colors.text['sub-500']};
  display: flex;
  flex-wrap: nowrap;
  font-size: 12px;
  font-weight: 600;
  gap: 5px;
  margin-left: 5px;
  align-items: center;
`;

export const ChangeAccess = styled.div`
  display: flex;
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  font-size: 14px;
  font-weight: 600;
  width: 220px;
  flex-direction: column;
  border: 1px solid ${colors.bg['soft-200']};
  background-color: ${colors.bg['white-0']};
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12);
  color: ${colors.text['main-900']};
  p {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    color: ${colors.text['sub-500']};
    margin: 10px 12px 4px;
  }
  z-index: 1000;
  div {
    padding: 8px 12px;
    display: flex;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    border-radius: 6px;
    margin: 2px 4px;
    :hover {
      background-color: ${colors.bg['weak-100']};
    }
    span {
      font-size: 14px;
      font-weight: 400;
    }
  }
`;

export const ContainerChangeAccess = styled.div`
  font-size: 11px;
  cursor: pointer;
  color: white;
  display: flex;
  align-items: center;
  margin-left: 5px;
  flex-wrap: nowrap;
  position: relative;
`;

export const TooltipContainer = styled.div`
  & > #switch-platform-tooltip {
    padding: 8px !important;
  }
`;

export const SwitchIconButton = styled.button<{ $active?: boolean; $filled?: boolean }>`
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: none;
  background: ${({ $filled }) => ($filled ? '#363BC4' : 'transparent')};
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  flex-shrink: 0;
  &:hover {
    background: ${({ $filled }) => ($filled ? '#2D32AA' : colors.bg['weak-100'])};
  }
`;

export const IconChip = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 6px;
  background: #363BC4;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 0 !important;
`;

export const ContainerLogoChangeAccess = styled.div<{ content }>`
  display: flex;
  gap: 15px;
  align-items: center;
  &&:hover::after {
    content: "${({ content }) => content}";
    position: absolute;
    top: 100%;
    left: 20px;
    background: ${colors.bg['surface-700']};
    color: white;
    font-size: 11px;
    padding: 4px 8px;
    border-radius: 4px;
    white-space: nowrap;
    z-index: 10000000;
  }
  @media (max-width: 767px) {
    &&:hover::after {
      background-color: unset;
      content: '';
    }
  }
`;

export const UserOptions = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  position: relative;
  justify-content: end;
  align-items: end;
  div {
    display: flex;
  }
`;

export const PermissionContainer = styled.div`
  font-size: 11px;
  color: ${colors.text['sub-500']};
  font-weight: 600;
  display: flex;
  gap: 3px;
  h1 {
    font-size: 11px;
    color: ${colors.Blue300};
  }
`;

export const Welcome = styled.span`
  color: #000;
`;

export const Expand = styled(ExpandIcon)<{ expanded, color }>`
  align-self: center;
  fill: ${({ color }) => color};
  margin-left: 10px;
  transition: transform 0.2s ease-in-out;
  transform: rotate(${({ expanded }) => (expanded ? 180 : 0)}deg);
`;

export const ContainerLogo = styled.div`
  margin-left: 20px;
  display: flex;
  height: 100%;
  align-items: center;
`;

export const List = styled.div`
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08);
  border: 1px solid #74747433;
  border-radius: 0 0 8px 8px;
  border-top: none;
  position: absolute;
  top: 57px;
  padding: 10px 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  background-color: ${colors.White};
  gap: 10px;
  z-index: 1001;
`;

export const Item = styled.a`
  cursor: pointer;
  color: #77818b;
  width: 100%;
  text-decoration: none;
  white-space: nowrap;
`;

export const ItemTitle = styled.span`
  margin-left: 10px;
  color: #000;
  &:hover {
    color: ${colors.Blue300};
  }
`;

export const TabList = styled.div`
  display: flex;
  align-items: flex-end;
  border-bottom: 1px solid ${colors.Grey100};
  margin-bottom: 16px;
  padding-top: 20px;
  gap: 32px;
  overflow-x: auto;
`;

export const TabItem = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  gap: 5px;
`;

export const Tab = styled.button<{ isActive: boolean }>`
  position: relative;
  display: inline-block;
  background: none;
  border: none;
  padding: 0;
  font-size: 13px;
  font-weight: bold;
  color: ${({ isActive }) => (isActive ? colors.Blue300 : colors.Grey500)};
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    color: ${colors.Blue300};
  }
`;

export const TabLine = styled.div<{ isActive: boolean }>`
  background: ${({ isActive }) => (isActive ? colors.Blue300 : 'transparent')};
  width: 100%;
  height: 10px;
  border-radius: 3px 3px 0 0;
  animation: grow 0.5s;
  @keyframes grow {
    from { width: 0; }
    to { width: 100%; }
  }
`;

export const HeaderRightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const CelsiusAiHeaderButton = styled.button<{ active?: boolean; clicking?: boolean; thinking?: boolean }>`
  position: relative;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: none;
  background: transparent;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;

  svg {
    position: relative;
    z-index: 2;
  }

  &:not([data-active="true"]):hover svg {
    animation: cai-shake 0.9s ease-out;
  }

  &[data-active="true"]::before {
    content: '';
    position: absolute;
    inset: 4px;
    border-radius: 50%;
    background: linear-gradient(180deg, ${colors.brand.primary.base}, ${colors.Accent});
    z-index: 1;
    animation: cai-bg-in 0.32s ease-out;
  }

  @keyframes cai-shake {
    0%, 100% { transform: rotate(0); }
    10% { transform: rotate(-20deg); }
    22% { transform: rotate(17deg); }
    34% { transform: rotate(-13deg); }
    48% { transform: rotate(10deg); }
    62% { transform: rotate(-7deg); }
    78% { transform: rotate(4deg); }
  }

  @keyframes cai-bg-in {
    from {
      transform: scale(0.3);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }

  @media (max-width: 810px) {
    display: none;
  }
`;

export const CelsiusAiTooltip = styled.span`
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: ${colors.bg['surface-700']};
  color: ${colors.White};
  font-size: 11px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 6px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease;
  z-index: 10;

  ${CelsiusAiHeaderButton}:hover & {
    opacity: 1;
  }
`;

export const NewBadge = styled.span`
  position: absolute;
  top: -16px;
  right: -24px;
  background-color: ${colors.Blue300};
  color: white;
  font-size: 10px;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  line-height: 1;
  white-space: nowrap;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
`;
